import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { api } from "../services/api";

import auth from "./authSlice";
import user from "./user";
import categoryReducer from "./category";
import networkReducer from "./network";
import top5Reducer from "./top5";
import recommendedReducer from "./recommended";
import videoReducer from "./video";
import channelReducer from "./channel";
import playlistReducer from "./playlist";
import playlistCategories from "./playlistCategories";
import conf from "./conf/confSlice";


const reducers = combineReducers({
  auth,
  user,
  categories: categoryReducer,
  network: networkReducer,
  top5: top5Reducer,
  recommended: recommendedReducer,
  video: videoReducer,
  channel: channelReducer,
  playlist: playlistReducer,
  playlistCategories:playlistCategories,
  conf:conf,
  [api.reducerPath]: api.reducer,
});

const persistConfig = {
  key: "mytv-root",
   storage,  
  whitelist: ["auth","user","video", "channel","conf"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware),
  devTools: true,
});

const persistor = persistStore(store);
setupListeners(store.dispatch);

export { store, persistor };
